import React, { PropTypes } from 'react';
import GainAdjustmentForm from './GainAdjustmentForm';
import axios from './../../../constants/axios';
import { SubmissionError } from 'redux-form';
import alert from 'alertify.js';

class GainAdjustment extends React.Component {

   saveGainAdjustment = (values) => {
      return axios.post('/gainAdjustment/saveGainAdjustment', values)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Inventory Gain Created.');
               this.context.router.push('/presentStock');
            } else {
               alert.error('Something went unexpected. Call Rasel.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Something not right. Rasel, where are you?');
            }
         });
   };


   render() {
      return (
         <div>
            <h3>Item Gain Form</h3>
            <GainAdjustmentForm saveGainAdjustment={this.saveGainAdjustment} />
         </div>
      );
   }
}
GainAdjustment.contextTypes = {
   router: PropTypes.object
};
export default GainAdjustment;



/** WEBPACK FOOTER **
 ** ./src/components/StockManagement/GainAdjustment/GainAdjustment.js
 **/